import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { CATEGORIES_FETCH } from "../actions/types";
import { categoriesFetchSuccess } from "../actions";
import { authorizationHeader } from "../utils/apiUtil";
import axios from "axios";
import axiosRetry from "axios-retry";

axiosRetry(axios, {
  retries: 3,
  retryDelay: (retryCount) => {
    return retryCount * 1000;
  },
});

const REACT_APP_API_URL = process.env.REACT_APP_API_URL;

// API
const categoriesFetchRequest = async (payload) => {
  return await axios
    .get(`${REACT_APP_API_URL}/categories`, {
      headers: authorizationHeader("Bearer"),
    })
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

// WORKER
function* categoriesFetch({ payload }) {
  try {
    const data = yield call(categoriesFetchRequest, payload);
    yield put(categoriesFetchSuccess(data));
  } catch (error) {
  }
}

// WATCHER
function* categoriesFetchWatcher() {
  yield takeEvery(CATEGORIES_FETCH, categoriesFetch);
}

export default function* rootSaga() {
  yield all([fork(categoriesFetchWatcher)]);
}
